var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5823 22c-.1116 0-.2158-.0433-.295-.1217l-9.2877-9.2891-9.28777 9.2891c-.07833.0784-.18332.1217-.29498.1217s-.21582-.0433-.29498-.1217c-.16249-.1625-.16249-.4266 0-.5891l9.28773-9.2884-9.2869-9.28913c-.16249-.1625-.16249-.42667 0-.58917.07833-.07917.18332-.1225.29415-.1225s.21582.04333.29498.12167l9.28777 9.28913 9.2886-9.2883c.0783-.07833.1833-.12167.295-.12167.1116 0 .2158.04334.2949.12167.1625.1625.1625.42667 0 .58917l-9.2894 9.28833 9.2878 9.2883c.1625.1625.1625.4267 0 .5892-.0784.0792-.1825.1225-.2942.1225z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2eaf1f8ad9da55932ec3142cd0ddbf26.svg";
export { ForwardRef as ReactComponent };